import { numberMap } from '../../utils';

class AnimatedParticle extends Phaser.GameObjects.Particles.Particle {
  constructor (emitter) {
    super(emitter);
    // this.t = 0;
    // this.i = 0;
    this.customAngle = _.random(359);
    this.customAngleRotation = _.random(0.1, 5);
    // this.customTargetScale = _.random(0.9, 1);
  }

  update (delta, step, processors) {
    var result = super.update(delta, step, processors);

    this.customAngle += this.customAngleRotation;

    if (this.customAngle > 360) {
      this.customAngle -= 360;
    }

    this.angle = this.customAngle;
    this.rotation = Phaser.Math.DegToRad(this.customAngle);

    if (this.lifeCurrent < 500) {
      let life = _.clamp(this.lifeCurrent, 0, 500);
      let alpha = numberMap(life, 500, 0, 1, 0);
      this.alpha = alpha;
    }

    return result;
  }
}

export default AnimatedParticle;
